export const TIMEOUT_PARAMETER = {
  FETCH_PROFILES: 60000,
  AUTO_REFRESH: 5000,
};
